/**
 * Legacy DedupeApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.dedupeApi`) keep resolving.
 *
 * The actual DedupeApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/dedupe/dedupe-api.service.ts
 */
angular.module("acme.common.service.dedupeApi", [
  "acme.common.factory.apiVersion",
]);
